import LoginRecommend from '../constants/LoginRecommend';
import { createSelector } from 'reselect';

const getLoginRequirementState = state => state.loginRequirement;

const getLoginRequirementFromState = createSelector(getLoginRequirementState, ({
  loginRequirement
}) => loginRequirement);
export const getStagedEmail = createSelector(getLoginRequirementState, ({
  stagedEmail
}) => stagedEmail);
export const getStagedRememberLogin = createSelector(getLoginRequirementState, ({
  stagedRememberLogin
}) => stagedRememberLogin);
export const getUseDark = createSelector(getLoginRequirementState, ({
  useDark
}) => useDark);
export const getLoginRedirectUrl = createSelector(getLoginRequirementState, ({
  loginRedirectUrl
}) => loginRedirectUrl);
export const getAllowFbSignup = createSelector(getLoginRequirementState, ({
  allowFbSignup
}) => allowFbSignup);
export const getHideSignupLink = createSelector(getLoginRequirementState, ({
  hideSignupLink
}) => hideSignupLink);
export const getSignupParams = createSelector(getLoginRequirementState, ({
  signupParams
}) => signupParams);
export const getLoginPortalId = createSelector(getLoginRequirementFromState, loginRequirement => loginRequirement && loginRequirement.portalId);
export const getLoginRequirementRequestStatus = createSelector(getLoginRequirementState, ({
  loginRequirementRequestStatus
}) => loginRequirementRequestStatus);
export const getRequiredLoginType = createSelector(getLoginRequirementFromState, loginRequirement => loginRequirement && loginRequirement.loginType);
export const getIsHardRequirement = createSelector(getLoginRequirementFromState, loginRequirement => loginRequirement && loginRequirement.hardRequirement);
export const getHasSsoRequirement = createSelector(getLoginRequirementState, ({
  hasSsoRequirement
}) => hasSsoRequirement);
export const getSsoError = createSelector(getLoginRequirementState, ({
  ssoError
}) => ssoError);
export const isGoogleRecommended = createSelector([getRequiredLoginType, getIsHardRequirement], (required, hard) => required === LoginRecommend.GOOGLE && hard === false);
export const isMicrosoftRecommended = createSelector([getRequiredLoginType, getIsHardRequirement], (required, hard) => required === LoginRecommend.MICROSOFT && hard === false);
export const isGoogleRequired = createSelector([getRequiredLoginType, getIsHardRequirement], (required, hard) => required === LoginRecommend.GOOGLE && hard === true);
export const isSsoRequired = createSelector([getRequiredLoginType, getIsHardRequirement], (required, hard) => required === LoginRecommend.SSO && hard);
export const isSsoAvailable = createSelector([getHasSsoRequirement], ssoRequirement => ssoRequirement);
export const getLoginRequirement = createSelector([getHasSsoRequirement, getStagedEmail, getStagedRememberLogin, getLoginRequirementFromState], (hasSsoRequirement, stagedEmail, stagedRememberLogin, loginRequirement) => ({
  hasSsoRequirement,
  stagedEmail,
  stagedRememberLogin,
  loginRequirement
}));